// NOTE: Also add an entry in IInterventionTypeMap

export const interventionTypes = ["selection", "labeling", "teleop"];
